import { InputHTMLAttributes, useRef, useState } from 'react';
import Input from '../Input';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    message?: string;
    valid?: boolean;
    setFieldValue: (field: string, value: string) => void;
    showSuggestions: boolean;
    onPick: (value: string) => void;
    suggestions: { text: string; value: string; data?: any }[];
}

function AutocompleteInput({ showSuggestions, suggestions, onPick, setFieldValue, ...props }: Props) {
    const suggestionsRef = useRef<HTMLDivElement>(null);
    return (
        <>
            <Input
                label={props.label}
                type={props.type}
                name={props.name}
                className={props.className}
                id={props.id}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                message={props.message}
                valid={props.valid}
                disabled={props.disabled}
            />
            {showSuggestions && !props.disabled && suggestions.length > 0 && (
                <div className="form-select__content form-select__content--suggestions" ref={suggestionsRef}>
                    <div className="form-select__content-wrapper">
                        <ul className="list-unstyled form-select__list">
                            {suggestions.map((option) => (
                                <li className="form-select__list-item" key={option.value}>
                                    <button
                                        type="button"
                                        className="form-select-item text-xs"
                                        onClick={() =>
                                            onPick(
                                                props.name === 'inn'
                                                    ? `${option.value} / ${option.data.inn}`
                                                    : option.value,
                                            )
                                        }
                                    >
                                        {props.name === 'inn' ? `${option.text} / ${option.data.inn}` : option.text}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
}

export default AutocompleteInput;
